import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import InsertRokub from "./components/InsertRokub/InsertRokub";
import { GetAllRokub } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import TblRokub from "./components/TblRokub/TblRokub";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function Rokub() {
  const { rokubDataPagination } = useSelector((state) => ({
    rokubDataPagination: state.rokub.rokubDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: rokubDataPagination.Limit,
          Page: rokubDataPagination.Page,
          Name: "",
        };
        await dispatch(GetAllRokub(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id={"flashing"}/>} />
        <div className="top-buttons">
          {(read("rokubRules").accessRegister !== false) && <InsertRokub />}
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TblRokub />
      </MuiPaper>
    </>
  );
}

export default Rokub;
